// stickyMenuChoices.js

(function (window) {
    var isChoicesJSLoaded = false;
    var callbacks = [];

    // Function to load the Choices.js script dynamically
    window.loadChoicesJS = function (callback) {
        if (isChoicesJSLoaded) {
            // If the API is already loaded, execute the callback immediately
            callback();
        } else {
            // Add the callback to the queue
            callbacks.push(callback);

            if (!document.getElementById('choices-js')) {
                // Create the script element if it hasn't been created
                var scriptTag = document.createElement('script');
                scriptTag.id = 'choices-js';
                scriptTag.src = "https://cdn.jsdelivr.net/npm/choices.js/public/assets/scripts/choices.min.js";
                scriptTag.async = true;

                // Load the CSS
                var linkTag = document.createElement('link');
                linkTag.rel = 'stylesheet';
                linkTag.href = "https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css";
                linkTag.id = 'choices-css';

                // Append the CSS to the head
                document.head.appendChild(linkTag);

                // Set up event listener to detect when Choices.js is loaded
                scriptTag.onload = function () {
                    isChoicesJSLoaded = true;
                    callbacks.forEach(function (cb) { cb(); });
                    callbacks = [];
                };

                // Append the script to the body
                document.body.appendChild(scriptTag);
            }
        }
    };
})(window);
